import React from 'react';
import { Button } from 'office-ui-fabric-react';
import RegisterForm from './common/RegisterForm';
import imgCity from './imgs/city.jpg';
import imgLogo from './imgs/login-logo.png';

export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);
    }

    scrollToTop() {
        this.refs.divRegisterForm.scrollTop = 0;
    }

    render() {
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-u-md7 p0">
                        <img className="vhc100 w100p object-fit-cover" src={imgCity} />
                    </div>
                    <div className="ms-Grid-col ms-u-md5 p0">
                        <div ref="divRegisterForm" className="vhc100 overflow-auto">
                            <div className="p20">
                                <div className="p20 plr40" style={{textAlign: 'center'}}>
                                    <img style={{width: 250}} src={imgLogo} />
                                </div>
                                <RegisterForm onRegisted={() => this.scrollToTop()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./client/components/Register.js